import { useCallback, useState } from 'react';
import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { Divider, useTheme } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import HorizontalListing from '../../../../Components/HorizontalListing';
import { textCategory } from '../../../../Components/Reservation/constants';
import ResponsiveText from '../../../../Components/ResponsiveText';
import constants from '../../../../Config/constants';
import { numberToArray } from '../../../../Helper';
import { Listing } from '../../../../RTK/api/reservations/types';
import themeStyle, { globalSpacing } from '../../../../Theme/styles';

import useListingHandler from '../../controller/useListingHandler';

import ReservationCard, { CardProps } from '../Card';

const loader = numberToArray(3).map(() => ({ loading: true }));

const ListSectionsRender = ({
  data,
  title,
  isLoading,
  onBookNow,
}: {
  data?: Listing[];
  title: string;
  isLoading: boolean;
  onBookNow: CardProps['onBookNow'];
}) => {
  const theme = useTheme();
  const { selectedFilter } = useListingHandler();
  const [cardWidth, setCardWidth] = useState(300);

  const list = isLoading ? loader : data;

  const _renderItem = useCallback(
    ({ index, item }) => (
      <View
        key={`${item?.store?.id}.${index}`}
        dataSet={{ media: ids.itemContainer }}
        style={[styles.itemContainer, { width: cardWidth }]}
      >
        <ReservationCard
          {...item}
          params={selectedFilter}
          onBookNow={onBookNow}
        />
      </View>
    ),
    [cardWidth, selectedFilter, onBookNow],
  );

  const _onLayout = useCallback((event) => {
    const width = event.nativeEvent.layout.width;
    const divisor = width <= 673 ? 1.2 : width <= 896 ? 2.1 : 3.1;
    setCardWidth(width / divisor);
  }, []);

  if (isLoading || lodashIsEmpty(data)) return null;

  return (
    <View style={themeStyle.spacingTop} onLayout={_onLayout}>
      <View
        style={[
          !constants.isWeb && themeStyle.pageHorizontalSpacing,
          themeStyle.spacingBottomSmall,
        ]}
      >
        <ResponsiveText category={textCategory.HEADING}>{title}</ResponsiveText>
      </View>
      <View style={[styles.itemWrapper, themeStyle.spacingBottom]}>
        <HorizontalListing
          // @ts-ignore - HorizontalListing is js file, data is array it should accept it
          data={list}
          renderItem={_renderItem}
          arrowContentStyles={{ backgroundColor: theme['color-info-500'] }}
          useScrollView
        />
      </View>
      <Divider style={themeStyle.sectionSeparator} />
    </View>
  );
};

const padding = 5; // for hover scaling to not get cut off
const itemSpacing = globalSpacing / 2; // spacing between item horizontally
const { ids, styles } = StyleSheet.create({
  itemWrapper: {
    marginHorizontal: constants.isWeb
      ? -(itemSpacing + padding / 2)
      : -(padding / 2), // to offset horizontal padding of each item
    marginTop: -(padding / 2), // to offset vertical padding of each item
  },
  itemContainer: {
    marginHorizontal: constants.isWeb ? itemSpacing : globalSpacing,
    padding: padding,
  },
});

export default ListSectionsRender;
